import { BadgeCheck, CircleDollarSign } from "lucide-react";
import React from "react";

import { brl } from "../lib/formato";

// Selo do produto na comanda da mesa (dono, 24/09/2026): quitado = "pago ·
// PIX" em verde; pago em parte = "pago R$ 2,00 · falta R$ 4,00" em âmbar.
// `pago` vem de `pagoDoItem` (lib/contaMesa).
export default function SeloPagoItem({ pago, className = "" }) {
  if (!pago) return null;
  if (pago.quitado) {
    return (
      <span className={`inline-flex items-center gap-1 text-[11px] font-semibold text-emerald-600 dark:text-emerald-400 max-w-full ${className}`}
            data-e2e="comanda-item-pago">
        <BadgeCheck className="w-3 h-3 shrink-0" />
        <span className="truncate">pago{pago.forma ? ` · ${pago.forma}` : ""}</span>
      </span>
    );
  }
  return (
    <span className={`inline-flex items-center gap-1 text-[11px] font-semibold text-amber-600 dark:text-amber-400 ${className}`}
          data-e2e="comanda-item-parcial">
      <CircleDollarSign className="w-3 h-3 shrink-0" />
      pago {brl(pago.parcial)} · falta {brl(pago.restante)}
    </span>
  );
}
